
const API_ROOT = 'https://app-node.talkdev.com:3021';
// const API_ROOT = 'https://app-node-talkdev.ondotmail.com:3035';


const webPath = 'https://talkdev.com'
// const webPath = 'https://talkdev.ondotmail.com'


export { API_ROOT , webPath};